import { flyingCarpet } from "@features/flying-carpet/useFlyingCarpet"
import { useMatchQuery } from "@hooks/useIsMobile"
import { useHydrating, useRouterEvents } from "eddev/routing"
import { FlyingCarpetDesktop } from "./FlyingCarpet.Desktop"
import { FlyingCarpetMobile } from "./FlyingCarpet.Mobile"

export function FlyingCarpet() {
  const hydrating = useHydrating()
  const isMobile = useMatchQuery("(max-width: 600px)")

  useRouterEvents((e) => {
    if (e.type === "navigate:start" || (e.type === "clicked" && e.mode !== "native")) {
      flyingCarpet.close()
    }
  })

  if (hydrating) {
    return null
  } else if (isMobile) {
    return <FlyingCarpetMobile />
  } else {
    return <FlyingCarpetDesktop />
  }
}
